function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M8 16.203c4.29 0 7.836-3.547 7.836-7.836S12.289.531 7.992.531C3.703.531.164 4.078.164 8.367c0 4.29 3.547 7.836 7.836 7.836zm0-1.008a6.808 6.808 0 01-6.82-6.828 6.8 6.8 0 016.812-6.82 6.82 6.82 0 016.836 6.82A6.815 6.815 0 018 15.195zm-1.008-2.93c.203 0 .367-.093.492-.28l4.055-6.337a.719.719 0 00.14-.382c0-.282-.25-.461-.5-.461-.163 0-.32.093-.429.28l-3.781 5.97L4.922 8.53c-.133-.172-.274-.242-.445-.242a.484.484 0 00-.485.492c0 .14.055.274.149.39l2.336 2.813c.164.204.32.282.515.282z",
  fill: "#56BA78"
});

var SvgTick = function SvgTick(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    viewBox: "0 0 16 17",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgTick, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/tick.a092898f.svg";
export { ForwardRef as ReactComponent };